import d from "./index73.js";
import a from "./index49.js";
import u from "./index60.js";
import R from "./index97.js";
import F from "./index98.js";
import g from "./index69.js";
import A from "./index52.js";
import C from "./index63.js";
import E from "./index66.js";
const b = ["content-type", "content-length"];
function U(r, o, e) {
  if (e !== "content-only") {
    r.set(o);
    return;
  }
  Object.entries(o || {}).forEach(([t, s]) => {
    b.includes(t.toLowerCase()) && r.set(t, s);
  });
}
const x = (r) => encodeURIComponent(r).replace(
  /%([0-9A-F]{2})/gi,
  (o, e) => String.fromCharCode(parseInt(e, 16))
);
function B(r) {
  const o = A({}, r), e = (i) => a.hasOwnProp(o, i) ? o[i] : void 0, t = e("data");
  let s = e("withXSRFToken");
  const l = e("xsrfHeaderName"), c = e("xsrfCookieName");
  let n = e("headers");
  const m = e("auth"), p = e("baseURL"), h = e("allowAbsoluteUrls"), S = e("url");
  if (o.headers = n = C.from(n), o.url = E(
    g(p, S, h, o),
    e("params"),
    e("paramsSerializer")
  ), m) {
    const i = a.getSafeProp(m, "username") || "", f = a.getSafeProp(m, "password") || "";
    try {
      n.set(
        "Authorization",
        "Basic " + btoa(i + ":" + (f ? x(f) : ""))
      );
    } catch (w) {
      throw u.from(w, u.ERR_BAD_OPTION_VALUE, r);
    }
  }
  if (a.isFormData(t) && (d.hasStandardBrowserEnv || d.hasStandardBrowserWebWorkerEnv || a.isReactNative(t) ? n.setContentType(void 0) : a.isFunction(t.getHeaders) && U(n, t.getHeaders(), e("formDataHeaderPolicy"))), d.hasStandardBrowserEnv && (a.isFunction(s) && (s = s(o)), s === !0 || s == null && R(o.url))) {
    const f = l && c && F.read(c);
    f && n.set(l, f);
  }
  return o;
}
export {
  B as default
};
